import { IonIcon } from '@ionic/react'
import { checkmark } from 'ionicons/icons'

/** Single confirmation checkbox covering every detail the operator must review. */
export const DetailsAckBlock = ({
  labels,
  acked,
  hasError,
  onAckedChange,
}: {
  labels: string[]
  acked: boolean
  hasError: boolean
  onAckedChange: (acked: boolean) => void
}) => {
  if (labels.length === 0) return null

  const checkboxClasses = [
    'assignment-detail__ack-checkbox',
    acked ? 'assignment-detail__ack-checkbox--checked' : '',
    hasError ? 'assignment-detail__ack-checkbox--error' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className='assignment-detail__hero-block'>
      <label className={checkboxClasses}>
        <span
          className={`assignment-detail__custom-check ${acked ? 'assignment-detail__custom-check--active' : ''}`}
          aria-hidden='true'
        >
          {acked && <IonIcon icon={checkmark} />}
        </span>
        <input
          type='checkbox'
          checked={acked}
          className='sr-only'
          aria-invalid={hasError}
          onChange={(e) => onAckedChange(e.target.checked)}
        />
        <span className='assignment-detail__ack-labels'>
          {labels.map((label) => (
            <span key={label}>{label}</span>
          ))}
        </span>
      </label>
    </div>
  )
}
